import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { ActionsProps } from '@lib/components/ReactHookForm/types';
import styles from './ImportForm.module.scss';

type Props = { canClear: boolean; onClear: () => void };

export default function ImportFormActions(props: ActionsProps & Props) {
  const { loading, canClear, onClear } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.actions}>
      <Button
        type="submit"
        buttonType={ButtonTypes.primaryFilled}
        buttonText={t('import')}
        leftIcon="check"
        fullWidth
        disabled={loading}
      />
      {canClear && (
        <Button
          type="button"
          buttonType={ButtonTypes.secondaryOutlined}
          buttonText={t('reset')}
          fullWidth
          disabled={loading}
          onClick={onClear}
        />
      )}
    </div>
  );
}
